"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathologyInvoices = void 0;
exports.pathologyInvoices = [
    {
        type: "CLINICAL",
        guid: "a2e97025-b1b2-4799-86fc-ba5d48f4b35d",
        billing_type: "BWH CYTOLOGY",
        charge_code_type: "Split",
        patient_type: "",
        filler_number: {
            number: "PATH_CMX_AUT_010_non_matching_pro_tech_codes-2022-5f4e164343524c8fa4c9ceea68093234",
            issuer: "EPIC",
            type: "SPECIMEN_NUMBER"
        },
        billing_provider_name: "null",
        billing_provider_number: {
            number: "1521674",
            issuer: "EPIC",
            type: "IDNO"
        },
        ordering_provider_name: "null",
        ordering_provider_number: {
            number: "1000154",
            issuer: "EPIC",
            type: "IDNO"
        },
        performing_provider_name: "null",
        performing_provider_number: {
            number: "1521674",
            issuer: "EPIC",
            type: "IDNO"
        },
        transactions: [
            {
                guid: "1c752c3d-e2b8-4b3a-a827-a4e9fd9526a7",
                sequence_number: 1000,
                date_of_service: "2022-08-18",
                datetime_of_service: "2022-08-18 00:00:00 EDT",
                transaction_type: "CG",
                transaction_id: 1630,
                source_transaction_id: "S17755001",
                transaction_posting_date: "2021-04-20",
                alt_transaction_description: "FINE NEEDLE ASPIRATION, RIGHT THYROID NO",
                department_code: "10030010328",
                fee_schedule: "5000356",
                place_of_service: "BWH_LNWTHYND",
                procedure: {
                    procedure_id: null,
                    procedure_uid: null,
                    evidence_source_uid: null,
                    procedure_name: null,
                    procedure_code: "88173",
                    type: null,
                    units: 1,
                    sequence_number: 1,
                    transaction_id: null,
                    automate: false,
                    confidence: 0,
                    evidence: [],
                    used: true
                },
                modifiers: [],
                diagnoses: [
                    {
                        diagnosis_uid: null,
                        diagnosis_code: "E04.1",
                        evidence_source_uid: null,
                        automate: false,
                        confidence: 0,
                        sequence_number: 1,
                        type: "ICD10",
                        evidence: [],
                        used: true
                    }
                ]
            },
            {
                guid: "92d8c98b-fc3e-4a3c-b91c-620579dcd482",
                sequence_number: 2000,
                date_of_service: "2022-08-18",
                datetime_of_service: "2022-08-18 00:00:00 EDT",
                transaction_type: "CG",
                transaction_id: 1631,
                source_transaction_id: "S17755002",
                transaction_posting_date: "2021-04-20",
                alt_transaction_description: "FINE NEEDLE ASPIRATION, RIGHT THYROID NO",
                department_code: "10030010328",
                fee_schedule: "5000356",
                place_of_service: "BWH_LNWTHYND",
                technical_code: {
                    units: 1,
                    code: "31000093",
                    used: true,
                    automated: false,
                    sequence_number: 0,
                    evidence: []
                },
                modifiers: [],
                diagnoses: [
                    {
                        diagnosis_uid: null,
                        diagnosis_code: "E04.1",
                        evidence_source_uid: null,
                        automate: false,
                        confidence: 0,
                        sequence_number: 1,
                        type: "ICD10",
                        evidence: [],
                        used: true
                    }
                ]
            }
        ]
    },
    {
        type: "ASSEMBLED",
        guid: "3a41622a-ac5f-4297-bcf5-b9b6d59914de",
        billing_type: "BWH CYTOLOGY",
        charge_code_type: "Split",
        patient_type: "",
        filler_number: {
            number: "PATH_CMX_AUT_010_non_matching_pro_tech_codes-2022-5f4e164343524c8fa4c9ceea68093234",
            issuer: "EPIC",
            type: "SPECIMEN_NUMBER"
        },
        billing_provider_name: "null",
        billing_provider_number: {
            number: "1521674",
            issuer: "EPIC",
            type: "IDNO"
        },
        ordering_provider_name: "null",
        ordering_provider_number: {
            number: "1000154",
            issuer: "EPIC",
            type: "IDNO"
        },
        performing_provider_name: "null",
        performing_provider_number: {
            number: "1521674",
            issuer: "EPIC",
            type: "IDNO"
        },
        transactions: [
            {
                guid: "c4ed02a9-3eed-4026-8819-21e3e0dfb01f",
                sequence_number: 1000,
                date_of_service: "2022-08-18",
                datetime_of_service: "2022-08-18 00:00:00 EDT",
                transaction_type: "CG",
                transaction_id: 1637,
                source_transaction_id: "S17755001",
                transaction_posting_date: "2021-04-20",
                alt_transaction_description: "FINE NEEDLE ASPIRATION, RIGHT THYROID NO",
                department_code: "10030010328",
                fee_schedule: "5000356",
                place_of_service: "BWH_LNWTHYND",
                technical_code: {
                    units: 1,
                    code: "31000093",
                    evidence_source_uid: "43567d57-8885-4126-acfa-90c428facb4e",
                    confidence: 0.88,
                    used: true,
                    automated: false,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0962921687548064,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.04873762978313534,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "m needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 489,
                                        end: 515,
                                        level: "ngram",
                                        content: "M.D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0435297444260605,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "m needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 489,
                                        end: 515,
                                        level: "ngram",
                                        content: "M.D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        }
                    ]
                },
                procedure: {
                    procedure_id: null,
                    procedure_uid: null,
                    evidence_source_uid: "43567d57-8885-4126-acfa-90c428facb4e",
                    procedure_name: null,
                    procedure_code: "88173",
                    type: null,
                    units: 1,
                    sequence_number: 1,
                    transaction_id: null,
                    automate: false,
                    confidence: 0.88,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0962921687548064,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.04873762978313534,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "m needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 489,
                                        end: 515,
                                        level: "ngram",
                                        content: "M.D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0435297444260605,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "m needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 489,
                                        end: 515,
                                        level: "ngram",
                                        content: "M.D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        }
                    ],
                    used: true
                },
                modifiers: [],
                diagnoses: [
                    {
                        diagnosis_uid: null,
                        diagnosis_code: "E04.1",
                        evidence_source_uid: "0ff4ceb5-52fd-4f94-a76e-1b29b4b5df58",
                        automate: false,
                        confidence: 0.48,
                        sequence_number: 1,
                        type: "ICD10",
                        evidence: [
                            {
                                type: "Ngram",
                                score: 0.01590401785714285,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "histori nodul",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 726,
                                            end: 755,
                                            level: "ngram",
                                            content: "History: right thyroid nodule"
                                        },
                                        {
                                            start: 725,
                                            end: 755,
                                            level: "sentence",
                                            content: " History: right thyroid nodule"
                                        }
                                    ]
                                }
                            }
                        ],
                        used: true
                    }
                ]
            }
        ]
    },
    {
        type: "PROCESSED",
        guid: "2647f9b4-3ba0-42c2-9bf7-d20023ea19e6",
        billing_type: "BWH CYTOLOGY",
        charge_code_type: "Split",
        patient_type: "",
        filler_number: {
            number: "PATH_CMX_AUT_010_non_matching_pro_tech_codes-2022-5f4e164343524c8fa4c9ceea68093234",
            issuer: "EPIC",
            type: "SPECIMEN_NUMBER"
        },
        billing_provider_name: "null",
        billing_provider_number: {
            number: "1521674",
            issuer: "EPIC",
            type: "IDNO"
        },
        ordering_provider_name: "null",
        ordering_provider_number: {
            number: "1000154",
            issuer: "EPIC",
            type: "IDNO"
        },
        performing_provider_name: "null",
        performing_provider_number: {
            number: "1521674",
            issuer: "EPIC",
            type: "IDNO"
        },
        transactions: [
            {
                guid: "273412d3-3220-45d7-aa98-5298dba65351",
                sequence_number: 1000,
                date_of_service: "2022-08-18",
                datetime_of_service: "2022-08-18 00:00:00 EDT",
                transaction_type: "CG",
                transaction_id: 1676,
                source_transaction_id: "S17755001",
                transaction_posting_date: "2021-04-20",
                alt_transaction_description: "FINE NEEDLE ASPIRATION, RIGHT THYROID NO",
                department_code: "10030010328",
                fee_schedule: "5000356",
                place_of_service: "BWH_LNWTHYND",
                technical_code: {
                    units: 1,
                    code: "31000093",
                    evidence_source_uid: "43567d57-8885-4126-acfa-90c428facb4e",
                    confidence: 0.88,
                    used: true,
                    automated: false,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0962921687548064,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.04873762978313534,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "m needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 489,
                                        end: 515,
                                        level: "ngram",
                                        content: "M.D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0435297444260605,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "m needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 489,
                                        end: 515,
                                        level: "ngram",
                                        content: "M.D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        }
                    ]
                },
                procedure: {
                    procedure_id: null,
                    procedure_uid: null,
                    evidence_source_uid: "43567d57-8885-4126-acfa-90c428facb4e",
                    procedure_name: null,
                    procedure_code: "88173",
                    type: null,
                    units: 1,
                    sequence_number: 1,
                    transaction_id: null,
                    automate: false,
                    confidence: 0.88,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0962921687548064,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.04873762978313534,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "m needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 489,
                                        end: 515,
                                        level: "ngram",
                                        content: "M.D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0435297444260605,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "m needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 489,
                                        end: 515,
                                        level: "ngram",
                                        content: "M.D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        }
                    ],
                    used: true
                },
                modifiers: [],
                diagnoses: [
                    {
                        diagnosis_uid: null,
                        diagnosis_code: "E04.1",
                        evidence_source_uid: "0ff4ceb5-52fd-4f94-a76e-1b29b4b5df58",
                        automate: false,
                        confidence: 0.48,
                        sequence_number: 1,
                        type: "ICD10",
                        evidence: [
                            {
                                type: "Ngram",
                                score: 0.01590401785714285,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "histori nodul",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 726,
                                            end: 755,
                                            level: "ngram",
                                            content: "History: right thyroid nodule"
                                        },
                                        {
                                            start: 725,
                                            end: 755,
                                            level: "sentence",
                                            content: " History: right thyroid nodule"
                                        }
                                    ]
                                }
                            }
                        ],
                        used: true
                    }
                ]
            }
        ]
    },
    {
        type: "SUBMITTED",
        guid: "613bbf81-098d-4adc-8f51-be3c0fbce1cb",
        billing_type: "BWH CYTOLOGY",
        charge_code_type: "Split",
        patient_type: "",
        filler_number: {
            number: "PATH_CMX_AUT_010_non_matching_pro_tech_codes-2022-5f4e164343524c8fa4c9ceea68093234",
            issuer: "EPIC",
            type: "SPECIMEN_NUMBER"
        },
        billing_provider_name: "null",
        billing_provider_number: {
            number: "1521674",
            issuer: "EPIC",
            type: "IDNO"
        },
        ordering_provider_name: "null",
        ordering_provider_number: {
            number: "1000154",
            issuer: "EPIC",
            type: "IDNO"
        },
        performing_provider_name: "null",
        performing_provider_number: {
            number: "1521674",
            issuer: "EPIC",
            type: "IDNO"
        },
        transactions: [
            {
                guid: "bf555cbb-f476-4ddf-a4a8-fd5b3840bef4",
                sequence_number: 1000,
                type: "PB",
                date_of_service: "2022-08-18",
                datetime_of_service: "2022-08-18 00:00:00 EDT",
                transaction_type: "CG",
                transaction_id: 1677,
                source_transaction_id: "S17755001",
                transaction_posting_date: "2021-04-20",
                alt_transaction_description: "FINE NEEDLE ASPIRATION, RIGHT THYROID NO",
                department_code: "10030010328",
                fee_schedule: "5000356",
                place_of_service: "BWH_LNWTHYND",
                procedure: {
                    procedure_id: null,
                    procedure_uid: null,
                    evidence_source_uid: "43567d57-8885-4126-acfa-90c428facb4e",
                    procedure_name: null,
                    procedure_code: "88173",
                    type: null,
                    units: 1,
                    sequence_number: 1,
                    transaction_id: null,
                    automate: false,
                    confidence: 0.88,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0962921687548064,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.04873762978313534,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "m needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 489,
                                        end: 515,
                                        level: "ngram",
                                        content: "M.D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0435297444260605,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "m needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 489,
                                        end: 515,
                                        level: "ngram",
                                        content: "M.D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        }
                    ],
                    used: true
                },
                modifiers: [],
                diagnoses: [
                    {
                        diagnosis_uid: null,
                        diagnosis_code: "E04.1",
                        evidence_source_uid: "0ff4ceb5-52fd-4f94-a76e-1b29b4b5df58",
                        automate: false,
                        confidence: 0.48,
                        sequence_number: 1,
                        type: "ICD10",
                        evidence: [
                            {
                                type: "Ngram",
                                score: 0.01590401785714285,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "histori nodul",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 726,
                                            end: 755,
                                            level: "ngram",
                                            content: "History: right thyroid nodule"
                                        },
                                        {
                                            start: 725,
                                            end: 755,
                                            level: "sentence",
                                            content: " History: right thyroid nodule"
                                        }
                                    ]
                                }
                            }
                        ],
                        used: true
                    }
                ]
            },
            {
                guid: "069d70a5-6f65-4f4d-af82-0f29ce58f8a0",
                sequence_number: 1001,
                type: "HB",
                date_of_service: "2022-08-18",
                datetime_of_service: "2022-08-18 00:00:00 EDT",
                transaction_type: "CG",
                transaction_id: 1678,
                source_transaction_id: "S17755001",
                transaction_posting_date: "2021-04-20",
                alt_transaction_description: "FINE NEEDLE ASPIRATION, RIGHT THYROID NO",
                department_code: "10030010328",
                fee_schedule: "5000356",
                place_of_service: "BWH_LNWTHYND",
                technical_code: {
                    units: 1,
                    code: "31000093",
                    evidence_source_uid: "43567d57-8885-4126-acfa-90c428facb4e",
                    confidence: 0.88,
                    used: true,
                    automated: false,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d fine",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 508,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.12587412587412594,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0962921687548064,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "d needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 491,
                                        end: 515,
                                        level: "ngram",
                                        content: "D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.04873762978313534,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "m needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 489,
                                        end: 515,
                                        level: "ngram",
                                        content: "M.D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0435297444260605,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "m needl",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 489,
                                        end: 515,
                                        level: "ngram",
                                        content: "M.D.\\n \\n \\n      FINE NEEDLE"
                                    },
                                    {
                                        start: 317,
                                        end: 493,
                                        level: "sentence",
                                        content: " Cytotechnologist:   Khristine Kayren Ham, CT (ASCP)\\n Resident/Fellow:    Edward  Richardson, M.D., Ph.D.; Nicolas  Wyvekens, M.D.\\n Pathologist:        Katharine  Horback, M.D."
                                    },
                                    {
                                        start: 498,
                                        end: 548,
                                        level: "sentence",
                                        content: "      FINE NEEDLE ASPIRATION, RIGHT THYROID NODULE"
                                    }
                                ]
                            }
                        }
                    ]
                },
                modifiers: [],
                diagnoses: [
                    {
                        diagnosis_uid: null,
                        diagnosis_code: "E04.1",
                        evidence_source_uid: "0ff4ceb5-52fd-4f94-a76e-1b29b4b5df58",
                        automate: false,
                        confidence: 0.48,
                        sequence_number: 1,
                        type: "ICD10",
                        evidence: [
                            {
                                type: "Ngram",
                                score: 0.01590401785714285,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "histori nodul",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 726,
                                            end: 755,
                                            level: "ngram",
                                            content: "History: right thyroid nodule"
                                        },
                                        {
                                            start: 725,
                                            end: 755,
                                            level: "sentence",
                                            content: " History: right thyroid nodule"
                                        }
                                    ]
                                }
                            }
                        ],
                        used: true
                    }
                ]
            }
        ]
    }
];
//# sourceMappingURL=pathology-invoices.js.map